/* eslint-disable react-hooks/rules-of-hooks */
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import {
  Container,
  Row,
  Col,
  Table,
  UncontrolledTooltip,
  Modal,
} from "reactstrap";

// Redux
import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

import Duration from "luxon/src/duration.js";

import PerfectScrollbar from "react-indiana-drag-scroll";

//Assets imports section
import "./ManagerPanelFirstContainer.scss";
import "../../common.scss";
import { useInView } from "react-intersection-observer";
import { getSkills } from "../../../../../../store/manager/actions";

const durationFormat = (seconds) => {
  let format = "";
  if (seconds < 60) {
    format = "ss's'";
  } else if (seconds < 3600) {
    format = "mm'm' ss's'";
  } else {
    format = "hh'h' mm'm'";
  }
  const res = Duration.fromObject({ seconds }).toFormat(format);
  return res;
};

const index = ({ t, onExpand }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  const { dataSkills, dataActivity, dataGeneralFilter } = useSelector(
    (state) => state.Manager
  );
  const userPreferences =
    useSelector((state) => state.Login?.data?.preferences) || {};

  const dispatch = useDispatch();

  const [orderBy, setOrderBy] = useState({
    order: 1,
    orderBy: "queue_number",
    last: false,
  });

  const [timeControl, setTimeControl] = useState(null);
  const lastUpdateRef = useRef(new Date());
  const intervalRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  function dynamicSort(property, order) {
    const sortOrder = order === 1 ? -1 : 1;
    return function (a, b) {
      if (a[property] === undefined) return order;
      if (b[property] === undefined) return sortOrder;

      let result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const isShowSkill = (item) => {
    return (
      item?.queue_number > 0 ||
      item?.rcvd >= 0 ||
      item?.total_closed_skill >= 0 ||
      item?.abandon >= 0
    );
  };

  const generalData = useMemo(() => {
    const listOfSkill = dataSkills?.data?.listOfSkills || [];
    if (!listOfSkill.length) return [];

    const activityData = dataActivity?.data?.skills;

    return listOfSkill
      .map((skill) => {
        const activity = activityData?.find((act) => act.skill_id === skill.id);
        return {
          ...skill,
          ...activity,
        };
      })
      .filter((item) => isShowSkill(item));
  }, [dataSkills, dataActivity]);

  const data = useMemo(() => {
    return [...generalData].sort(dynamicSort(orderBy.orderBy, orderBy.order));
  }, [generalData, orderBy]);

  const renderSkills = useCallback(() => {
    if (!data.length)
      return (
        <td colSpan="10" align="center">
          <div className="mt-4 queue-attendance-text-ico-wrapper">
            <div className="empty-queue-ico">
              <i className="mr-1 fas fa-user-friends"></i>
              <i className="fas fa-user-friends"></i>
            </div>
            <div id="empty-queue-text">
              <div className="text-italic my-1">
                {t(
                  "There are no indications of Queued, Received, Ended, or Abandoned conversations"
                )}
              </div>
            </div>
          </div>
        </td>
      );

    return data.map((item, i) => (
      <div className="container-table-row" key={i}>
        <div className="container-table-cell">
          <label className={`container-table-text ${mainTheme}`} id="skillName">
            {item?.queue ?? "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            className={`container-table-text ${mainTheme}`}
            id="onqueuename"
          >
            {item?.queue_number ?? "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label className={`container-table-text ${mainTheme}`} id="tmenumber">
            {item?.tme ? durationFormat(item?.tme) : "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            id="tmexnumber"
            className={`container-table-text ${mainTheme}`}
          >
            {item?.tmex ? durationFormat(item?.tmex) : "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            id="Receivednumber"
            className={`container-table-text ${mainTheme}`}
          >
            {item?.rcvd ?? "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            id="aFinishednumber"
            className={`container-table-text ${mainTheme}`}
          >
            {item?.total_closed_skill ?? "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            id="Abandonmentnumber"
            className={`container-table-text ${mainTheme}`}
          >
            {item?.abandon ?? "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label id="TMRnumber" className={`container-table-text ${mainTheme}`}>
            {item?.tmru ? durationFormat(item?.tmru) : "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label id="TMOnumber" className={`container-table-text ${mainTheme}`}>
            {item?.tmo ? durationFormat(item?.tmo) : "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            id="Goalnumber"
            className={`container-table-text ${mainTheme}`}
          >
            {item?.goal !== null && item?.time !== null
              ? `${item?.goal}% - ${durationFormat(item?.time)}`
              : "-"}
          </label>
        </div>
        <div className="container-table-cell">
          <label
            id="Accomplishednumber"
            className={`container-table-text ${mainTheme}`}
          >{`${item?.accomplished ?? "-"}%`}</label>
        </div>
        <div className="container-table-cell">
          <label
            id="CSATnumber"
            className={`container-table-text ${mainTheme}`}
          >
            {`${item?.avg_csat ?? "-"}%`}
          </label>
        </div>
      </div>
    ));
  }, [data, t]);

  const orderByQueue = (name = null) => {
    let order = orderBy.order;
    if (name) {
      order *= -1;
      if (orderBy.orderBy !== name) {
        order = 1;
      } else if (order === 1 && orderBy.orderBy === name) {
        order = 1;
        name = "queue_number";
      }
    } else {
      name = orderBy.orderBy;
    }
    setOrderBy({
      order,
      orderBy: name,
    });
  };

  const handlePage = () => {
    if (!inView) return;
    dispatch(getSkills(dataGeneralFilter));
    lastUpdateRef.current = new Date();
  };

  useEffect(() => {
    handlePage();
  }, [timeControl]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeControl(new Date());
    }, userPreferences?.refresh_time ?? 60000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [dataGeneralFilter]);

  useEffect(() => {
    if (inView && lastUpdateRef.current) {
      const now = new Date();
      const diff = now - lastUpdateRef.current;
      if (diff >= userPreferences?.refresh_time) {
        setTimeControl(new Date());
      }
    }
  }, [inView]);

  return (
    <div ref={ref} className="w-100 mr-3">
      <Container className="d-flex w-100 px-0 mx-2" fluid={true}>
        <Row className="w-100 mx-0">
          <Col className="px-0" xs="12">
            <span className={`section-title ${mainTheme}`}>
              {t("Skills summary")}
            </span>
          </Col>
          <div className={`container-full ${mainTheme} skills-summary`}>
            <PerfectScrollbar hideScrollbars={false} ignoreElements={".container-table-text"} className="scroll w-100 h-100">
              <div className="container-table">
                <div
                  className={`container-table-row container-table-header ${mainTheme}`}
                >
                  <div className="container-table-cell">
                    <label
                      className={`container-table-label ${mainTheme}`}
                      id="skillName"
                    >
                      {t("Skill")}
                    </label>
                  </div>
                  <div className="container-table-cell">
                    <label
                      className={`container-table-label ${mainTheme} order`}
                      id="onqueuename"
                      onClick={() => {
                        orderByQueue("queue_number");
                      }}
                    >
                      {t("Queue")}
                      {orderBy.orderBy === "queue_number" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-14`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"onqueuename"}
                    >
                      {t("Chats on queue")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      className={`container-table-label ${mainTheme} order`}
                      id="tmenumber"
                      onClick={() => {
                        orderByQueue("tme");
                      }}
                    >
                      {t("AWT")}
                      {orderBy.orderBy === "tme" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip placement="right" target={"tmenumber"}>
                      {t(
                        "Average waiting time of clients in the queue in the filtered period"
                      )}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="tmexnumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("tmex");
                      }}
                    >
                      {t("MWT")}
                      {orderBy.orderBy === "tmex" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"tmexnumber"}
                    >
                      {t(
                        "Maximum wait time of the client who is in the queue for the longest time in the filtered period"
                      )}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="Receivednumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("rcvd");
                      }}
                    >
                      {t("Received")}
                      {orderBy.orderBy === "rcvd" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"Receivednumber"}
                    >
                      {t(
                        "Number of clients who entered the platform (queue or agent)"
                      )}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="aFinishednumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("total_closed_skill");
                      }}
                    >
                      {t("aFinished")}
                      {orderBy.orderBy === "total_closed_skill" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"aFinishednumber"}
                    >
                      {t("Number of conversations that were completed")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="Abandonmentnumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("abandon");
                      }}
                    >
                      {t("Abandonment")}
                      {orderBy.orderBy === "abandon" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"Abandonmentnumber"}
                    >
                      {t("Number of clients who abandoned attendance")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="TMRnumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("tmru");
                      }}
                    >
                      {t("TMR")}
                      {orderBy.orderBy === "tmru" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip placement="right" target={"TMRnumber"}>
                      {t("Average response time sent by agents throughout the conversation")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="TMOnumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("tmo");
                      }}
                    >
                      {t("TMO")}
                      {orderBy.orderBy === "tmo" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip placement="right" target={"TMOnumber"}>
                      {t("Average operating time")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="Goalnumber"
                      className={`container-table-label ${mainTheme}`}
                    >
                      <div id="GoalValue">{t("SL - Goal")}</div>
                      {dataSkills?.data?.listOfSkills?.some((e) => !e.goal) && (
                        <>
                          <i
                            id="warning-goal"
                            className="bx bxs-error-circle text-warning font-size-16"
                          />
                          <UncontrolledTooltip
                            placement="bottom"
                            target="warning-goal"
                            className="warning-tooltip"
                          >
                            {t(
                              "Some skills do not have a service level goal set"
                            )}
                          </UncontrolledTooltip>
                        </>
                      )}
                    </label>

                    <UncontrolledTooltip placement="right" target={"GoalValue"}>
                      {t("Skill setting values for the service level goal")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="Accomplishednumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("accomplished");
                      }}
                    >
                      {t("SL - Accomplished")}
                      {orderBy.orderBy === "accomplished" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"Accomplishednumber"}
                    >
                      {t(
                        "Calculation performed: [total conversations assigned within the META time determined in the skill] / [total conversations assigned in the skill]"
                      )}
                    </UncontrolledTooltip>
                  </div>
                  <div className="container-table-cell">
                    <label
                      id="CSATnumber"
                      className={`container-table-label ${mainTheme} order`}
                      onClick={() => {
                        orderByQueue("avg_csat");
                      }}
                    >
                      {t("CSAT")}
                      {orderBy.orderBy === "avg_csat" ? (
                        <i
                          className={`mdi mdi-chevron-${
                            orderBy.order === 1 ? "down" : "up"
                          } font-size-16`}
                        />
                      ) : (
                        <i className={`mdi mdi-arrow-right font-size-16`} />
                      )}
                    </label>
                    <UncontrolledTooltip
                      placement="right"
                      target={"CSATnumber"}
                    >
                      {t("Average CSAT")}
                    </UncontrolledTooltip>
                  </div>
                </div>
                <div className="container-table-body">{renderSkills()}</div>
              </div>
            </PerfectScrollbar>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default withTranslation()(index);
